import axios from 'axios';

import { AxiosErrorResponse } from './types';
import { createApiErrorFromAxiosError } from './utils';

export const axiosInstance = axios.create({
  withCredentials: true,
  // Fail fast on a dead/flaky connection instead of hanging for the OS socket default.
  timeout: 15000
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosErrorResponse) => {
    if (
      error.request.responseType === 'blob' &&
      error.response &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().includes('json')
    ) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.addEventListener('load', () => {
          if (error.response) {
            error.response.data = JSON.parse(reader.result as string);
            resolve(Promise.reject(error));
          }
        });

        reader.addEventListener('error', () => {
          reject(error);
        });

        error.response && reader.readAsText(error.response.data);
      });
    }

    return Promise.reject(createApiErrorFromAxiosError(error));
  }
);
